import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  FormArray,
  Validators,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable, startWith, map, combineLatest } from 'rxjs';
import { Country } from 'src/app/core/models/country.model';
import { QuotationInfo } from 'src/app/core/models/quotations-info.model';
import { Quote } from 'src/app/core/models/quote.model';
import { TravelPurpose } from 'src/app/core/models/travel-purpose.model';
import { Traveller } from 'src/app/core/models/traveller.model';
import { ContentLoaderService } from 'src/app/core/services/content-loader.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
const FAMILY_CATEGORY_MASTER_ID = '2e891a8d-5f4c-4be7-8e07-3f212f82624a'; // Example ID for Family
const GROUP_CATEGORY_MASTER_ID = 'bc06d924-a3f7-4b6a-b380-43ea6d173aca';
const INBOUND_TRAVEL_TYPE_MASTER_ID = 'b7bc748b-70b8-4e58-bec3-986503917cda';
const INDIVIDUAL_CATEGORY_MASTER_ID = 'bc7b3c24-8d59-4ad1-8298-52bebf1e15ca';
const DOMESTIC_TRAVEL_TYPE_MASTER_ID = '0bb14cab-9bdf-4204-9d87-b44036ea7b63';
export function atLeastOneProposerValidator(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const isAtLeastOneSelected = (formArray as FormArray).controls.some(
      (control) => control.get('isProposerATraveller')?.value
    );

    return isAtLeastOneSelected ? null : { atLeastOneRequired: true };
  };
}
export function minAgeValidation(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const isAtLeastOneAboveOrEqual3 = (formArray as FormArray).controls.some(
      (control) => {
        const age = control.get('age')?.value;
        return age !== null && age >= 3;
      }
    );

    return isAtLeastOneAboveOrEqual3 ? null : { minAgeRequired: true };
  };
}
// oldAgeRestrictionValidation(): ValidatorFn {
//   return (formArray: AbstractControl): ValidationErrors | null => {
//     const isAnyOldAgePersion = (formArray as FormArray).controls.some(
//       (control) => {
//         const age = control.get('age')?.value;
//         return age !== null && age > 80;
//       }
//     );

//     return isAnyOldAgePersion ? { oldAgeRestriction: true } : null;
//   };
// }
@Component({
  selector: 'app-get-quote',
  templateUrl: './get-quote.component.html',
  styleUrls: ['./get-quote.component.scss'],
})
export class GetQuoteComponent {
  submitted: boolean = false;
  filteredDestinations: Observable<Country[]> | undefined;
  selectedDestinations: Country[] = [];
  @ViewChild('destinationInput')
  destinationInput!: ElementRef<HTMLInputElement>;
  minTripStartDate: any = new Date();
  minTripEndDate: any;
  getTravelCategory: any[] = [];
  quotationFieldsForm = this.fb.group({
    travelPurpose: ['', Validators.required],
    destination: [''],
    tripStartDate: ['', Validators.required],
    tripEndDate: ['', Validators.required],
    travelingDays: [{ value: '', disabled: true }, Validators.required],
    numberOfTravelers: ['', Validators.required],
    travelersDetails: this.fb.array(
      [],
      [
        atLeastOneProposerValidator(),
        minAgeValidation(),
        this.maxTravelersValidator(10),
      ]
    ),
    quotationTemplate: [''],
    familyTypeID: ['', Validators.required],
    travelTypeID: ['', Validators.required],
    countryOfOrigin: [''],
    isDaysTrip: [false],
  });
  dateOfBirthMaxDate = moment().subtract(1, 'years');
  currentMessage!: string;
  formSubmitted: boolean = false;
  getTravelPurposeList: TravelPurpose[] = [];
  getCountriesList: Country[] = [];
  quotationId: string = '';
  isEditMode: boolean = false;
  quotesInfo!: QuotationInfo;
  quotesList: Quote[] = [];
  travellerList: Traveller[] = [];
  currentLanguage: string = '';
  flowTypeList: any[] = [];
  parsedData: string | null = null;
  messages = [
    'Initializing your Travel Insurance Policy purchase... Please hold on.',
    'Checking for the best policy options available for you.',
    'Calculating premiums and benefits to match your travel needs.',
    'Almost there! Just securing the best rates for your upcoming adventures.',
    'Finalizing the details of your Travel Insurance Policy.',
    'Thank you for your patience! The products that match your needs will be ready for you to choose from in just a few minutes.',
  ];
  defaultCountry = [
    {
      FromCountryId: '771c2959-b859-47a5-89bb-b31f3f5dd07a',
      FromCountryName: 'KENYA',
      FromCountrySourceID: 101,
      FromCountryCode: null,
      ToCountryCode: 'KE',
      ToCountrySourceId: 101,
      TocountryID: '771c2959-b859-47a5-89bb-b31f3f5dd07a',
      ToCountryName: 'KENYA',
    },
  ];
  familyCategoryMasterId: string = FAMILY_CATEGORY_MASTER_ID;
  getTravelTypeList: any[] = [];
  schegencountries: any[] = [];
  durationTypes: any[] = [
    { value: false, name: 'Max 92 Days Trip' },
    { value: true, name: 'Max 180 Days Trip' },
  ];
  public readonly INBOUND_TRAVEL_TYPE_MASTER_ID =
    'b7bc748b-70b8-4e58-bec3-986503917cda';
  public readonly PILGRIMAGE_TRAVEL_PURPOSE_MASTER_ID =
    'c764a795-950a-4969-b84c-9fd161ac30ee';
  public readonly DOMESTIC_TRAVEL_TYPE_MASTER_ID =
    '0bb14cab-9bdf-4204-9d87-b44036ea7b63';
  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private loader: LoaderService,
    private router: Router,
    private contentLoaderService: ContentLoaderService,
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
    private translate: TranslateService
  ) {
    this.route.params.subscribe((params) => {
      this.quotationId = params['quotationId'];
    });
    this.isEditMode = this.quotationId ? true : false;
    this.filteredDestinations = this.quotationFieldsForm
      .get('destination')
      ?.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value || ''))
      ) as Observable<Country[]>;
    this.currentLanguage = this.translate.currentLang;
    this.translate.onLangChange.subscribe((event: any) => {
      this.currentLanguage = event.lang;
      this.GetMasterData();
      console.log(
        'Language changed to in GetQuoteComponent:',
        this.currentLanguage
      );
      // You might want to re-fetch or re-process data if it's language-dependent
      // this.GetMasterData(); // Example: Re-fetch master data if it depends on language
    });
  }

  ngOnInit() {
    this.GetMasterData();
    this._setupTravelTypeSubscription();
    const familyTypeControl = this.quotationFieldsForm.get('familyTypeID');
    this.quotationFieldsForm
      .get('travelPurpose')
      ?.valueChanges.subscribe((val) => {
        this.selectedDestinations = [];
        this.quotationFieldsForm.get('travelTypeID')?.patchValue(null);
        this.quotationFieldsForm.get('countryOfOrigin')?.patchValue(null);
      });
    this.quotationFieldsForm
      .get('travelTypeID')
      ?.valueChanges.subscribe((val) => {
        this.quotationFieldsForm.get('countryOfOrigin')?.patchValue(null);
      });
    this.quotationFieldsForm
      .get('tripStartDate')
      ?.valueChanges.subscribe((val) => {
        this.minTripEndDate = val;
        this.quotationFieldsForm.get('tripEndDate')?.patchValue(null);
        this.quotationFieldsForm.get('travelingDays')?.patchValue(null);
      });
    const startDateControl = this.quotationFieldsForm.get('tripStartDate');
    const endDateControl = this.quotationFieldsForm.get('tripEndDate');

    if (startDateControl && endDateControl) {
      const startDate$ = startDateControl.valueChanges;
      const endDate$ = endDateControl.valueChanges;

      combineLatest([startDate$, endDate$])
        .pipe(
          map(([start, end]) => {
            if (start && end) {
              // Only proceed if both dates have values
              const startDate = new Date(start);
              const endDate = new Date(end);

              if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
                // Calculate the difference in days, adding 1 to include both the start and end dates
                return (
                  Math.abs(
                    (endDate.getTime() - startDate.getTime()) /
                      (1000 * 3600 * 24)
                  ) + 1
                );
              }
            }
            return 0; // Return 0 if either date is missing or invalid
          })
        )
        .subscribe((days: any) => {
          // Set the travelingDays only if days is greater than 0 to avoid setting it for invalid dates
          if (days > 0) {
            this.quotationFieldsForm
              .get('travelingDays')
              ?.patchValue(days, { emitEvent: false });
          }
        });
    }
    const numberOfTravelersControl =
      this.quotationFieldsForm.get('numberOfTravelers');

    if (familyTypeControl && numberOfTravelersControl) {
      familyTypeControl.valueChanges
        .pipe(startWith(familyTypeControl.value))
        .subscribe((selectedFamilyTypeID) => {
          if (selectedFamilyTypeID === INDIVIDUAL_CATEGORY_MASTER_ID) {
            // Set to 1 traveler and disable
            numberOfTravelersControl.setValue('1');
            numberOfTravelersControl.disable();
            numberOfTravelersControl.setValidators([Validators.required]);
            numberOfTravelersControl.updateValueAndValidity();
            this.numberOfTravelers();
          } else if (selectedFamilyTypeID === FAMILY_CATEGORY_MASTER_ID) {
            // Enable and apply maxTravelersValidator for family type
            numberOfTravelersControl.enable();
            numberOfTravelersControl.setValidators([
              Validators.required,
              this.maxTravelersValidator(10),
            ]);
            numberOfTravelersControl.updateValueAndValidity();
          } else {
            // Enable and apply maxTravelersValidator for all other types
            numberOfTravelersControl.enable();
            numberOfTravelersControl.setValidators([
              Validators.required,
              this.maxTravelersValidator(10),
            ]);
            numberOfTravelersControl.updateValueAndValidity();
          }
        });
    }
  }
  maxTravelersValidator(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      console.log('maxTravelersValidator called with value:', control.value);
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return null; // Let required validator handle empty
      }
      const num = Number(value);
      if (isNaN(num) || num > max) {
        return { maxTravelers: true };
      }
      return null;
    };
  }
  oldAgeRestrictionValidationDynamic(
    schegencountries: any[],
    selectedDestinations: Country[]
  ): ValidatorFn {
    return (formArray: AbstractControl): ValidationErrors | null => {
      const schengenIds = new Set(
        (schegencountries || []).map((c: any) => c.ToCountryId)
      );
      const isExempt = selectedDestinations.some((dest) =>
        schengenIds.has(dest.TocountryID)
      );
      if (isExempt) {
        return null; // No error if Schengen
      }
      const isAnyOldAgePerson = (formArray as FormArray).controls.some(
        (control) => {
          const age = control.get('age')?.value;
          return age !== null && age > 80;
        }
      );
      return isAnyOldAgePerson ? { oldAgeRestriction: true } : null;
    };
  }
  GetQuotesInfo() {
    let params = {
      QuotationID: this.quotationId,
    };
    this.loader.show();
    this.restService
      .postData(params, 'api/Quotation/GetB2CQuotesInfo')
      .subscribe({
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.quotesInfo = data.rObj.GetQuotesInfo;
              this.quotesList = data.rObj.GetQuotes || [];
              this.travellerList = data.rObj.Traveller || [];
              let selectedDestinationsList = data.rObj.DestinationCountry || [];
              let selectedDestinationsIds = selectedDestinationsList.map(
                (sdl: any) => sdl.DestinationCountryID
              );
              this.selectedDestinations = this.getCountriesList.filter(
                (country) =>
                  selectedDestinationsIds.includes(country.TocountryID)
              );
              if (this.isEditMode) {
                this.SetFormFieldsValuesOnEditMode();
              }
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        },
      });
  }

  SetFormFieldsValuesOnEditMode() {
    this.quotationFieldsForm.patchValue({
      travelPurpose: this.quotesInfo.TravelPurposeID,
      tripStartDate: this.quotesInfo.FromDate,
      tripEndDate: this.quotesInfo.ToDate,
      travelingDays: this.quotesInfo.NoofDays?.toString(),
      numberOfTravelers: this.quotesInfo.NoofTravellers?.toString(),
    });

    this.getTravelersDetails.clear();
    for (const traveller of this.travellerList) {
      this.getTravelersDetails.push(
        this.newTravelersDetaileWithDefaultValues(traveller)
      );
    }
  }

  get getTravelersDetails(): FormArray {
    return this.quotationFieldsForm.get('travelersDetails') as FormArray;
  }

  newTravelersDetaile(numberOfTravelers: number): FormGroup {
    return this.fb.group({
      isProposerATraveller: [
        numberOfTravelers == 1 ? true : false,
        Validators.required,
      ],
      dateOfBirth: ['', Validators.required],
      age: [{ value: '', disabled: true }, Validators.required],
    });
  }

  newTravelersDetaileWithDefaultValues(traveller: Traveller): FormGroup {
    return this.fb.group({
      isProposerATraveller: [traveller.IsPolicyHolder, Validators.required],
      dateOfBirth: [traveller.DOB, Validators.required],
      age: [{ value: traveller.Age, disabled: true }, Validators.required],
    });
  }

  onProposerChange(selectedGroup: any, selected: boolean) {
    if (selected) {
      this.disableOtherProposerControls(selectedGroup);
    } else {
      this.enableAllProposerControls();
    }
    this.getTravelersDetails.updateValueAndValidity();
  }

  disableOtherProposerControls(selectedGroup: FormGroup) {
    this.getTravelersDetails.controls.forEach((group) => {
      if (group !== selectedGroup) {
        group.get('isProposerATraveller')?.disable();
      }
    });
  }

  enableAllProposerControls() {
    this.getTravelersDetails.controls.forEach((group) => {
      group.get('isProposerATraveller')?.enable();
    });
  }

  removeTravelersDetaile(i: number) {
    this.getTravelersDetails.removeAt(i);
  }

  remove(destination: Country): void {
    const index = this.selectedDestinations.indexOf(destination);
    if (index >= 0) {
      this.selectedDestinations.splice(index, 1);
      this.onFocus();
    }
    this.updateTravelersArrayValidators();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedCountry = this.getCountriesList.find(
      (country) => country.TocountryID === event.option.value
    );
    if (selectedCountry) {
      let selectedTravelPurpose =
        this.quotationFieldsForm.get('travelPurpose')?.value;
      if (selectedTravelPurpose === '9cc927ea-0447-4f83-bb46-699da28c428e') {
        this.selectedDestinations = [];
      }
      this.selectedDestinations.push(selectedCountry);
      this.destinationInput.nativeElement.value = '';
      this.quotationFieldsForm.get('destination')?.patchValue('');
      this.onFocus();
    }
    this.updateTravelersArrayValidators();
  }

  private _filter(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.getCountriesList.filter(
      (country) =>
        country.ToCountryName.toLowerCase().includes(filterValue) &&
        !this.selectedDestinations.some(
          (selected) => selected.TocountryID === country.TocountryID
        )
    );
  }

  onFocus() {
    this.filteredDestinations = this.quotationFieldsForm
      .get('destination')
      ?.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value || ''))
      ) as Observable<Country[]>;
  }

  // numberOfTravelers(): void {
  //   this.getTravelersDetails.clear();
  //   const numberOfTravelers: any =
  //     this.quotationFieldsForm.get('numberOfTravelers')?.value || 0;
  //   const validNumber = parseInt(numberOfTravelers, 10);

  //   if (!isNaN(validNumber) && validNumber > 0) {
  //     for (let i = 1; i <= validNumber; i++) {
  //       this.getTravelersDetails.push(
  //         this.newTravelersDetaile(numberOfTravelers)
  //       );
  //     }
  //   }
  // }
  numberOfTravelers(): void {
    const numberOfTravelersControl =
      this.quotationFieldsForm.get('numberOfTravelers');
    const numberOfTravelers: any = numberOfTravelersControl?.value || 0;
    const validNumber = parseInt(numberOfTravelers, 10);

    // Always update validity first
    numberOfTravelersControl?.updateValueAndValidity();

    // Only proceed if valid
    if (
      !numberOfTravelersControl?.invalid &&
      !isNaN(validNumber) &&
      validNumber > 0
    ) {
      this.getTravelersDetails.clear();
      for (let i = 1; i <= validNumber; i++) {
        this.getTravelersDetails.push(this.newTravelersDetaile(validNumber));
      }
      this.updateAgeValidatorsForTravelers(); // <--- Add this
    } else {
      // If invalid, do not clear or repopulate the array!
      // Optionally, you can clear the array here if you want no travelers shown when invalid:
      this.getTravelersDetails.clear();
    }
    this.updateTravelersArrayValidators();
  }
  private updateTravelersArrayValidators(): void {
    this.getTravelersDetails.setValidators([
      atLeastOneProposerValidator(),
      minAgeValidation(),
      this.oldAgeRestrictionValidationDynamic(
        this.schegencountries,
        this.selectedDestinations
      ),
    ]);
    this.getTravelersDetails.updateValueAndValidity();
  }
  private updateAgeValidatorsForTravelers(): void {
    this.getTravelersDetails.controls.forEach((travelerGroup) => {
      const ageControl = travelerGroup.get('age');
      if (ageControl) {
        ageControl.setValidators([Validators.required]);
        ageControl.updateValueAndValidity();
      }
    });
  }
  maxAgeValidator(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = parseInt(control.value, 10);
      if (!isNaN(value) && value > max) {
        return { maxAge: true };
      }
      return null;
    };
  }
  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  calculateAge(dob: Date): number {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  dateOfBirthChange(event: MatDatepickerInputEvent<Date>, index: number) {
    let dob = this.getTravelersDetails.at(index).get('dateOfBirth')?.value;
    let getAge = this.calculateAge(dob);
    this.getTravelersDetails.at(index).get('age')?.patchValue(getAge);
  }

  GetMasterData() {
    this.loader.show();
    let params = {
      id: '1', // Assuming 1 is for English and 2 for other languages
    };
    this.restService.postData(params, 'api/Quotation/GetMasterData').subscribe({
      next: (data: any) => {
        try {
          if (data.rcode == 200) {
            this.getTravelPurposeList = data.rObj.GetTravelPurpose || [];
            this.getCountriesList = data.rObj.GetCountries || [];
            this.getTravelCategory = data.rObj.family || [];
            this.getTravelTypeList = data.rObj.travelType || [];
            this.schegencountries = data.rObj.schegencountries || [];
            this.updateTravelersArrayValidators();
            if (this.isEditMode) {
              this.GetQuotesInfo();
            }
          } else {
            this.errorHandler.handleRcodeError(data);
          }
        } catch (error) {
          this.errorHandler.internalError();
        } finally {
          this.loader.hide();
        }
      },
      error: (error: any) => {
        this.loader.hide();
        this.errorHandler.handleStatusError(error);
      },
    });
  }

  // submit() {
  //   this.submitted = true;
  //   if (
  //     this.quotationFieldsForm.invalid ||
  //     this.selectedDestinations.length == 0
  //   ) {
  //     return;
  //   }

  //   let travelersDetails =
  //     this.quotationFieldsForm.get('travelersDetails')?.getRawValue() || [];
  //   let params = {
  //     FromCountryID: '771C2959-B859-47A5-89BB-B31F3F5DD07A',
  //     TravelPurposeID: this.quotationFieldsForm.get('travelPurpose')?.value,
  //     ToCountriesId: this.selectedDestinations.map(
  //       ({ ToCountrySourceId, TocountryID, ToCountryName, ToCountryCode }) => ({
  //         CountrySourceId: ToCountrySourceId,
  //         CountryId: TocountryID,
  //         CountryName: ToCountryName,
  //         CountryCode: ToCountryCode,
  //       })
  //     ),
  //     FromDate: moment(
  //       this.quotationFieldsForm.get('tripStartDate')?.value
  //     ).format('YYYY-MM-DD'),
  //     ToDate: moment(this.quotationFieldsForm.get('tripEndDate')?.value).format(
  //       'YYYY-MM-DD'
  //     ),
  //     NoofDays: parseInt(
  //       this.quotationFieldsForm.get('travelingDays')?.value || '',
  //       10
  //     ),
  //     NoofTravellers: parseInt(
  //       this.quotationFieldsForm.get('numberOfTravelers')?.value || '',
  //       10
  //     ),
  //     TravellersInfo: travelersDetails.map((td: any) => {
  //       return {
  //         DateofBirth: moment(td.dateOfBirth).format('YYYY-MM-DD'),
  //         Age: parseInt(td.age, 10),
  //         IsPolicyHolder: td.isProposerATraveller,
  //       };
  //     }),
  //   };

  //   this.formSubmitted = true;
  //   this.contentLoaderService
  //     .submitData('api/Quotation/GetB2CQuotes', params, this.messages)
  //     .subscribe({
  //       next: (data: any) => {
  //         try {
  //           if (typeof data === 'string') {
  //             this.currentMessage = data;
  //           } else if (data.rcode == 200) {
  //             this.formSubmitted = false;
  //             this.router.navigate([
  //               'quotation/quotation-premium',
  //               data.rObj.QuotationID,
  //             ]);
  //           } else {
  //             this.errorHandler.handleRcodeError(data);
  //           }
  //         } catch (error) {
  //           this.errorHandler.internalError();
  //         }
  //       },
  //       error: (error) => {
  //         this.errorHandler.handleStatusError(error);
  //       },
  //     });
  // }
  submit() {
    this.submitted = true;
    if (
      this.quotationFieldsForm.invalid ||
      this.selectedDestinations.length == 0
    ) {
      return;
    }

    let travelersDetails =
      this.quotationFieldsForm.get('travelersDetails')?.getRawValue() || [];
    let params = {
      FromCountryID: '771C2959-B859-47A5-89BB-B31F3F5DD07A',
      TravelPurposeID: this.quotationFieldsForm.get('travelPurpose')?.value,
      ToCountriesId: this.selectedDestinations.map(
        ({ ToCountrySourceId, TocountryID, ToCountryName, ToCountryCode }) => ({
          CountrySourceId: ToCountrySourceId,
          CountryId: TocountryID,
          CountryName: ToCountryName,
          CountryCode: ToCountryCode,
        })
      ),
      FromDate: moment(
        this.quotationFieldsForm.get('tripStartDate')?.value
      ).format('YYYY-MM-DD'),
      ToDate: moment(this.quotationFieldsForm.get('tripEndDate')?.value).format(
        'YYYY-MM-DD'
      ),
      NoofDays: parseInt(
        this.quotationFieldsForm.get('travelingDays')?.value || '',
        10
      ),
      NoofTravellers:
        parseInt(
          this.quotationFieldsForm.get('numberOfTravelers')?.value || '',
          10
        ) || null,
      TravellersInfo: travelersDetails.map((td: any) => {
        return {
          DateofBirth: moment(td.dateOfBirth).format('YYYY-MM-DD'),
          Age: parseInt(td.age, 10),
          IsPolicyHolder: td.isProposerATraveller,
        };
      }),
      isDaysTrip: this.quotationFieldsForm.get('isDaysTrip')?.value,
      travelTypeID: this.quotationFieldsForm.get('travelTypeID')?.value,
      familyTypeID: this.quotationFieldsForm.get('familyTypeID')?.value
        ? this.quotationFieldsForm.get('familyTypeID')?.value
        : null,
    };

    this.formSubmitted = true;
    this.contentLoaderService
      .submitData('api/Quotation/GetB2CQuotes', params, this.messages)
      .subscribe({
        next: (data: any) => {
          try {
            if (typeof data === 'string') {
              this.currentMessage = data;
            } else if (data.rcode == 200) {
              this.formSubmitted = false;
              this.router.navigate([
                'quotation/quotation-premium',
                data.rObj.QuotationID,
              ]);
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          }
        },
        error: (error) => {
          this.errorHandler.handleStatusError(error);
        },
      });
  }
  TryAgain() {
    window.location.reload();
  }
  private _setupTravelTypeSubscription(): void {
    this.quotationFieldsForm
      .get('travelTypeID')
      ?.valueChanges.pipe(
        startWith(this.quotationFieldsForm.get('travelTypeID')?.value) // Process initial value (e.g., from edit mode)
      )
      .subscribe((selectedTravelTypeId) => {
        this._handleTravelTypeChange(selectedTravelTypeId);
      });
  }
  private _handleTravelTypeChange(
    selectedTravelTypeId: string | null | undefined
  ): void {
    const destinationControl = this.quotationFieldsForm.get('destination');
    const countryOfOriginControl =
      this.quotationFieldsForm.get('countryOfOrigin');

    // Check if type is Inbound or Domestic
    const isCurrentlyInbound =
      selectedTravelTypeId === this.INBOUND_TRAVEL_TYPE_MASTER_ID;
    const isCurrentlyDomestic =
      selectedTravelTypeId === DOMESTIC_TRAVEL_TYPE_MASTER_ID;

    // Apply Kenya as default for both Inbound and Domestic
    if (isCurrentlyInbound || isCurrentlyDomestic) {
      // Set Kenya as destination and disable field
      this.selectedDestinations = [...this.defaultCountry];
      destinationControl?.setValue(null);
      destinationControl?.disable();
      if (this.destinationInput?.nativeElement) {
        this.destinationInput.nativeElement.value = '';
      }

      // Only enable Country of Origin for Inbound (not for Domestic)
      if (isCurrentlyInbound) {
        countryOfOriginControl?.setValidators([Validators.required]);
        countryOfOriginControl?.enable();
      } else {
        countryOfOriginControl?.setValue(null);
        countryOfOriginControl?.clearValidators();
        countryOfOriginControl?.disable();
      }
    } else {
      // Not Inbound or Domestic
      destinationControl?.enable();

      // Check if Kenya is selected as default and should be cleared
      const isKenyaSelectedAsDefault =
        this.selectedDestinations.length === 1 &&
        this.selectedDestinations[0].TocountryID ===
          this.defaultCountry[0].TocountryID;

      if (isKenyaSelectedAsDefault) {
        let shouldClearKenya = false;
        if (!this.isEditMode) {
          shouldClearKenya = true;
        } else if (
          this.quotesInfo &&
          (this.quotesInfo.travelTypeID ===
            this.INBOUND_TRAVEL_TYPE_MASTER_ID ||
            this.quotesInfo.travelTypeID === DOMESTIC_TRAVEL_TYPE_MASTER_ID)
        ) {
          shouldClearKenya = true;
        }
        if (shouldClearKenya) {
          this.selectedDestinations = [];
        }
      }

      // Handle Country of Origin for non-Inbound types
      countryOfOriginControl?.setValue(null);
      countryOfOriginControl?.clearValidators();
      countryOfOriginControl?.disable();
    }

    // Update validity
    destinationControl?.updateValueAndValidity();
    countryOfOriginControl?.updateValueAndValidity();
    this.onFocus();
  }
}
